"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printOtherSupplyLabel = exports.printBiasTapeLabel = exports.printElasticLabel = exports.printTrimLabel = exports.printThreadLabel = exports.printButtonProductLabel = exports.printSewingPatternLabel = exports.printRibbingLabel = exports.printZipperLabel = exports.printFabricLabel = void 0;
const __1 = require("..");
const utils_1 = require("./utils");
const printFabricLabel = (fabric, skus, doc, contentVal) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const variants = (_a = __1.getNumVariants(fabric)) !== null && _a !== void 0 ? _a : 1;
    for (let i = 0; i < variants; i++) {
        if (i > 0) {
            doc.addPage(utils_1.CONFIG.format, utils_1.CONFIG.orientation);
        }
        let textYPos = utils_1.CONFIG.verticalMargin;
        textYPos = utils_1.mediumText(doc, textYPos, `# ${(_b = skus[i]) !== null && _b !== void 0 ? _b : 'missing sku'}`);
        textYPos = utils_1.mediumText(doc, textYPos, `$ ${(_d = (_c = fabric.price) === null || _c === void 0 ? void 0 : _c[i]) !== null && _d !== void 0 ? _d : 'missing price'}`);
        textYPos = utils_1.smallText(doc, textYPos, `${fabric.name}`);
        const content = fabric.content
            ? __1.getFabricContent(fabric.content).join(', ')
            : contentVal;
        textYPos = utils_1.smallText(doc, textYPos, content !== null && content !== void 0 ? content : 'missing content', true);
        const lines = [];
        let widthCM = (_e = fabric.widthCM) === null || _e === void 0 ? void 0 : _e[0];
        if (__1.isFieldVarianted('widthCM', fabric.variantedFields))
            widthCM = (_f = fabric.widthCM) === null || _f === void 0 ? void 0 : _f[i];
        lines.push(`W: ${widthCM !== null && widthCM !== void 0 ? widthCM : 'missing width'}CM`);
        if (fabric.bundleOrRoll === __1.FabricAttributes.BundleOrRoll.Bundle) {
            lines.push(`L: ${(_h = (_g = fabric.lengthM) === null || _g === void 0 ? void 0 : _g[i]) !== null && _h !== void 0 ? _h : 'missing length'}M`);
        }
        utils_1.bottomAlignedText(doc, lines);
    }
    return `fabric-label(${fabric.name}).pdf`;
};
exports.printFabricLabel = printFabricLabel;
const printZipperLabel = (zipper, sku, doc) => {
    var _a, _b;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const length = zipper.lengthIn ? `${zipper.lengthIn}" ` : '';
    const info = `${length}${(_a = zipper.colour) === null || _a === void 0 ? void 0 : _a.join(' / ')}`;
    utils_1.smallText(doc, textYPos, info, true);
    let sellingUnit = zipper.sellingUnit === __1.ZipperAttributes.SellingUnit['Pack'] && zipper.packSize
        ? `${zipper.packSize} Pack`
        : zipper.sellingUnit;
    if (sellingUnit === __1.ZipperAttributes.SellingUnit.Hardware) {
        if (zipper.zipperHardwareSU === __1.ZipperAttributes.ZipperHardwareSU.Pack) {
            sellingUnit = `${zipper.packSize} Pack ${zipper.zipperHardwareType}`;
        }
        else {
            sellingUnit = `${zipper.zipperHardwareType}`;
        }
    }
    utils_1.bottomAlignedText(doc, [
        `${sellingUnit}`,
        `$ ${(_b = zipper.price) !== null && _b !== void 0 ? _b : 'missing price'}`
    ]);
    return `zipper-label(${sku}).pdf`;
};
exports.printZipperLabel = printZipperLabel;
const printRibbingLabel = (ribbing, sku, doc) => {
    var _a, _b, _c, _d;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const length = ribbing.lengthCM ? `${ribbing.lengthCM}CM ` : '';
    const info = `${length}${(_a = ribbing.colour) === null || _a === void 0 ? void 0 : _a.join(' / ')} ${((_b = ribbing.uses) === null || _b === void 0 ? void 0 : _b.length) === 1 ? (_c = ribbing.uses) === null || _c === void 0 ? void 0 : _c[0] : 'Multi-Use'}`;
    utils_1.smallText(doc, textYPos, info, true);
    const lines = [];
    if (ribbing.sellingUnit === __1.RibbingAttributes.SellingUnit['Pack'] && ribbing.packSize)
        lines.push(`${ribbing.packSize} Pack`);
    lines.push(`$ ${(_d = ribbing.price) !== null && _d !== void 0 ? _d : 'missing price'}`);
    utils_1.bottomAlignedText(doc, lines);
    return `ribbing-label(${sku}).pdf`;
};
exports.printRibbingLabel = printRibbingLabel;
const printSewingPatternLabel = (sewingPattern, sku, doc) => {
    var _a;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const info = `${sewingPattern.brand} ${sewingPattern.patternNumber}`;
    utils_1.smallText(doc, textYPos, info, true);
    utils_1.bottomAlignedText(doc, [`$ ${(_a = sewingPattern.price) !== null && _a !== void 0 ? _a : 'missing price'}`]);
    return `sewingPattern-label(${sku}).pdf`;
};
exports.printSewingPatternLabel = printSewingPatternLabel;
const printButtonProductLabel = (buttonProduct, sku, doc) => {
    var _a;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const info = `${buttonProduct.mixedWidth ? `Various Widths` : `${buttonProduct.widthMM}MM`} ${buttonProduct.buttonType}`;
    utils_1.smallText(doc, textYPos, info, true);
    const lines = [];
    if (buttonProduct.sellingUnit === __1.ButtonProductAttributes.SellingUnit['Pack'] &&
        buttonProduct.packSize)
        lines.push(`${buttonProduct.packSize} Pack`);
    lines.push(`$ ${(_a = buttonProduct.price) !== null && _a !== void 0 ? _a : 'missing price'}`);
    utils_1.bottomAlignedText(doc, lines);
    return `buttonProduct-label(${sku}).pdf`;
};
exports.printButtonProductLabel = printButtonProductLabel;
const printThreadLabel = (thread, sku, doc) => {
    var _a;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const info = `${thread.colour} ${thread.threadType} Thread`;
    utils_1.smallText(doc, textYPos, info, true);
    const lines = [];
    if (thread.sellingUnit === __1.ThreadAttributes.SellingUnit['Pack'] && thread.packSize)
        lines.push(`${thread.packSize} Pack`);
    lines.push(`$ ${(_a = thread.price) !== null && _a !== void 0 ? _a : 'missing price'}`);
    utils_1.bottomAlignedText(doc, lines);
    return `thread-label(${sku}).pdf`;
};
exports.printThreadLabel = printThreadLabel;
const printTrimLabel = (trim, sku, doc) => {
    var _a, _b, _c;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const info = `${__1.toFraction((_a = trim.widthIn) !== null && _a !== void 0 ? _a : 0, false)}" ` +
        `${(_b = trim.colour) === null || _b === void 0 ? void 0 : _b.join(' / ')} ${trim.trimType} ` +
        `Trim`;
    utils_1.smallText(doc, textYPos, info, true);
    utils_1.bottomAlignedText(doc, [`$ ${(_c = trim.price) !== null && _c !== void 0 ? _c : 'missing price'}`]);
    return `trim-label(${sku}).pdf`;
};
exports.printTrimLabel = printTrimLabel;
const printElasticLabel = (elastic, sku, doc) => {
    var _a, _b, _c;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    const info = `${__1.toFraction((_a = elastic.widthIn) !== null && _a !== void 0 ? _a : 0, false)}" ` +
        `${(_b = elastic.colour) === null || _b === void 0 ? void 0 : _b.join(' / ')} ${elastic.elasticType} ` +
        `Elastic`;
    textYPos = utils_1.smallText(doc, textYPos, info, true);
    const bundleSize = elastic.sellingUnit === __1.ElasticAttributes.SellingUnit.Bundle
        ? `${elastic.lengthM}M Bundle`
        : '';
    utils_1.smallText(doc, textYPos, bundleSize, true);
    const meterSize = elastic.sellingUnit === __1.ElasticAttributes.SellingUnit['By Meter'] ? `1M` : '';
    utils_1.smallText(doc, textYPos, meterSize, true);
    const packSize = elastic.sellingUnit === __1.ElasticAttributes.SellingUnit['Pack']
        ? `${elastic.packSize} Pack`
        : '';
    utils_1.smallText(doc, textYPos, packSize, true);
    const rollSize = elastic.sellingUnit === __1.ElasticAttributes.SellingUnit.Roll
        ? `${elastic.lengthM}M Roll`
        : '';
    utils_1.smallText(doc, textYPos, rollSize, true);
    utils_1.bottomAlignedText(doc, [`$ ${(_c = elastic.price) !== null && _c !== void 0 ? _c : 'missing price'}`]);
    return `elastic-label(${sku}).pdf`;
};
exports.printElasticLabel = printElasticLabel;
const printBiasTapeLabel = (biasTape, sku, doc) => {
    var _a, _b, _c;
    let textYPos = utils_1.CONFIG.verticalMargin;
    if (sku.length === 6)
        textYPos = utils_1.sixCharText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    else if (sku.length === 7)
        textYPos = utils_1.sevenCharText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    else
        textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    //textYPos = largeText(doc, textYPos, `${sku ?? 'missing sku'}`);
    const info = `${__1.toFraction((_a = biasTape.widthIn) !== null && _a !== void 0 ? _a : 0, false)}" ` +
        `${(_b = biasTape.colour) === null || _b === void 0 ? void 0 : _b.join(' / ')} ` +
        `Bias Tape`;
    textYPos = utils_1.smallText(doc, textYPos, info, true);
    const bundleSize = biasTape.sellingUnit === __1.BiasTapeAttributes.SellingUnit.Bundle
        ? `${biasTape.lengthM}M Bundle`
        : '';
    utils_1.smallText(doc, textYPos, bundleSize, true);
    const rollSize = biasTape.sellingUnit === __1.BiasTapeAttributes.SellingUnit.Roll
        ? `${biasTape.lengthM}M Roll`
        : '';
    utils_1.smallText(doc, textYPos, rollSize, true);
    const packageSize = biasTape.sellingUnit === __1.BiasTapeAttributes.SellingUnit.Package
        ? `${biasTape.lengthM}M Package`
        : '';
    utils_1.smallText(doc, textYPos, packageSize, true);
    const meterSize = biasTape.sellingUnit === __1.BiasTapeAttributes.SellingUnit['By Meter'] ? `1M` : '';
    utils_1.smallText(doc, textYPos, meterSize, true);
    utils_1.bottomAlignedText(doc, [`$ ${(_c = biasTape.price) !== null && _c !== void 0 ? _c : 'missing price'}`]);
    return `biasTape-label(${sku}).pdf`;
};
exports.printBiasTapeLabel = printBiasTapeLabel;
const printOtherSupplyLabel = (otherSupply, sku, doc) => {
    var _a;
    let textYPos = utils_1.CONFIG.verticalMargin;
    textYPos = utils_1.largeText(doc, textYPos, `${sku !== null && sku !== void 0 ? sku : 'missing sku'}`);
    // Distinction between selecting the otherSupplyType from the buttons vs Manually typing in a "custom" one
    let info = '';
    // if (
    //   !Object.values(osa.otherSupplyType).includes(
    //     otherSupply.otherSupplyType as otherSupplyType
    //   )
    // ) {
    //   info = `${otherSupply.colour} ${otherSupply.name ? otherSupply.name : ''}`;
    // } else {
    //   info = `${otherSupply.colour} ${otherSupply.otherSupplyType} ${
    //     otherSupply.name ? otherSupply.name : ''
    //   }`;
    // }
    info = `${otherSupply.colour} ${otherSupply.otherSupplyType} ${otherSupply.name ? otherSupply.name : ''}`;
    textYPos = utils_1.smallText(doc, textYPos, info, true);
    const lines = [];
    const meterSize = otherSupply.sellingUnit === __1.OtherSupplyAttributes.SellingUnit['By Meter']
        ? `By the meter`
        : '';
    if (meterSize !== '')
        lines.push(meterSize);
    //smallText(doc, textYPos, meterSize, true);
    const individualSize = otherSupply.sellingUnit === __1.OtherSupplyAttributes.SellingUnit.Individual ? `Per Piece` : '';
    if (individualSize !== '')
        lines.push(individualSize);
    //smallText(doc, textYPos, individualSize, true);
    const packSize = otherSupply.sellingUnit === __1.OtherSupplyAttributes.SellingUnit['Pack']
        ? `${otherSupply.packSize} Pack`
        : '';
    if (packSize !== '')
        lines.push(packSize);
    //smallText(doc, textYPos, packSize, true);
    const weightSize = otherSupply.sellingUnit === __1.OtherSupplyAttributes.SellingUnit['By Weight']
        ? `${otherSupply.weightLB}LB`
        : '';
    if (weightSize !== '')
        lines.push(weightSize);
    //smallText(doc, textYPos, weightSize, true);
    lines.push(`$ ${(_a = otherSupply.price) !== null && _a !== void 0 ? _a : 'missing price'}`);
    //bottomAlignedText(doc, [`$ ${otherSupply.price ?? 'missing price'}`]);
    utils_1.bottomAlignedText(doc, lines);
    return `otherSupply-label(${sku}).pdf`;
};
exports.printOtherSupplyLabel = printOtherSupplyLabel;
//# sourceMappingURL=printLabel.js.map